
export default function() {
    $('body').on('hover', ".entry-meta-wrapper .herald-share", function (e) {
        if (e.type === "mouseenter") {
            $(this).find('.meta-share-wrapper').slideDown();
        } else {
            $(this).find('.meta-share-wrapper').slideUp();
        }
    });
}
